export const ROUTE_ACCESS_RULES = [
  { prefix: '/session-clients', accessKey: '/session-clients' },
  { prefix: '/fitness-transactions/setup', accessKey: '/fitness-transactions/setup' },
  { prefix: '/addoutlet', accessKey: '/outlets' },
  { prefix: '/editoutlet', accessKey: '/outlets' },
  { prefix: '/add-employee', accessKey: '/employees' },
  { prefix: '/edit-employee', accessKey: '/employees' },
  { prefix: '/add-karyawan-module', accessKey: '/karyawanmodules' },
  { prefix: '/edit-karyawan-module', accessKey: '/karyawanmodules' },
  { prefix: '/membership-daily-stats', accessKey: '/membership-daily-stats' },
  { prefix: '/membership-monthly-stats', accessKey: '/membership-monthly-stats' },
  { prefix: '/add-membershippayment', accessKey: '/membership-payment' },
  { prefix: '/add-member', accessKey: '/members' },
  { prefix: '/edit-member', accessKey: '/members' },
  { prefix: '/add-membership', accessKey: '/membership-setting' },
  { prefix: '/edit-membership', accessKey: '/membership-setting' },
  { prefix: '/member-modules', accessKey: '/member-modules' },
  { prefix: '/add-member-module', accessKey: '/member-modules' },
  { prefix: '/edit-member-module', accessKey: '/member-modules' },
  { prefix: '/default-member-modules', accessKey: '/default-member-modules' },
  { prefix: '/defaultmodulekaryawan', accessKey: '/defaultmodulekaryawan' },
  { prefix: '/add-default-karyawan-module', accessKey: '/defaultmodulekaryawan' },
  { prefix: '/edit-default-karyawan-module', accessKey: '/defaultmodulekaryawan' },
  { prefix: '/add-default-member-module', accessKey: '/default-member-modules' },
  { prefix: '/edit-default-member-module', accessKey: '/default-member-modules' },
  { prefix: '/outlet-modules', accessKey: '/outlet-modules' },
  { prefix: '/add-outlet-module', accessKey: '/outlet-modules' },
  { prefix: '/edit-outlet-module', accessKey: '/outlet-modules' },
  { prefix: '/modules', accessKey: '/modules' },
  { prefix: '/addmodule', accessKey: '/modules' },
  { prefix: '/editmodule', accessKey: '/modules' },
  { prefix: '/missions', accessKey: '/missions' },
  { prefix: '/addmission', accessKey: '/missions' },
  { prefix: '/editmission', accessKey: '/missions' },
  { prefix: '/rewards', accessKey: '/rewards' },
  { prefix: '/addreward', accessKey: '/rewards' },
  { prefix: '/deposit/edit', accessKey: '/deposits' },
  { prefix: '/deposits', accessKey: '/deposits' },
  { prefix: '/user-balance', accessKey: '/user-balance' },
  { prefix: '/accounting-setup', accessKey: '/accounting-setup' },
  { prefix: '/fitness-finance', accessKey: '/operasional-finance' },
  { prefix: '/operasional-finance', accessKey: '/operasional-finance' },
  { prefix: '/asset-management', accessKey: '/accounting-setup' },
  { prefix: '/pos-categories', accessKey: '/pos-categories' },
  { prefix: '/pos-products', accessKey: '/pos-products' },
  { prefix: '/pos-customers', accessKey: '/pos-customers' },
  { prefix: '/pos-items', accessKey: '/pos-items' },
  { prefix: '/pos-laundry-methods', accessKey: '/pos-laundry-methods' },
  { prefix: '/pos-laundry-times', accessKey: '/pos-laundry-times' },
  { prefix: '/pos-purchases', accessKey: '/pos-purchases' },
  { prefix: '/pos-pengajuan-pembatalan', accessKey: '/pos-pengajuan-pembatalan' },
  { prefix: '/pos-approval-pembatalan', accessKey: '/pos-approval-pembatalan' },
  { prefix: '/pos-refund-void-approval', accessKey: '/pos-refund-void-approval' },
  { prefix: '/pos-stock-adjustments', accessKey: '/pos-stock-adjustments' },
  { prefix: '/pos-stock-opnames', accessKey: '/pos-stock-opnames' },
  { prefix: '/pos-vendors', accessKey: '/pos-vendors' },
  { prefix: '/pos-account-mappings', accessKey: '/pos-account-mappings' },
  { prefix: '/pos-sync-monitor', accessKey: '/pos-sync-monitor' },
  { prefix: '/report-center', accessKey: '/report-center' },
  { prefix: '/staff-transaction-summary', accessKey: '/staff-transaction-summary' },
  { prefix: '/member-activity-monitor', accessKey: '/member-activity-monitor' },
  { prefix: '/staff-shift-closing', accessKey: '/staff-shift-closing' },
  { prefix: '/reportcheckin', accessKey: '/reportcheckin' },
  { prefix: '/pt-schedule-setting', accessKey: '/pt-schedule-setting' },
  { prefix: '/fitness-transactions', accessKey: '/fitness-transactions' },
];

const normalizePath = value => {
  const normalized = (value || '').trim();
  if (!normalized) {
    return '';
  }
  if (normalized === '*') {
    return '*';
  }
  return normalized.startsWith('/') ? normalized : `/${normalized}`;
};

const pathMatches = (allowedPath, requiredPath) =>
  allowedPath === requiredPath || requiredPath.startsWith(`${allowedPath}/`);

export const readStoredAdminUser = () => {
  try {
    return JSON.parse(localStorage.getItem('userData') || '{}');
  } catch (error) {
    return {};
  }
};

export const getAdminActorType = (userData = readStoredAdminUser()) =>
  String(
    userData?.actor_type ??
    userData?.actorType ??
    userData?.role ??
    userData?.level ??
    ''
  )
    .trim()
    .toLowerCase();

export const isAdminUser = (userData = readStoredAdminUser()) => {
  const actorType = getAdminActorType(userData);
  return actorType === 'admin' || actorType === 'administrator';
};

export const isOutletUser = (userData = readStoredAdminUser()) =>
  getAdminActorType(userData) === 'outlet';

export const isKaryawanUser = (userData = readStoredAdminUser()) =>
  getAdminActorType(userData) === 'karyawan';

export const isManagementUser = (userData = readStoredAdminUser()) =>
  isAdminUser(userData) || isOutletUser(userData);

export const getAllowedPaths = userData => {
  const rawPaths = Array.isArray(userData?.allowed_paths)
    ? userData.allowed_paths
    : Array.isArray(userData?.allowedPaths)
      ? userData.allowedPaths
      : [];

  const pathSet = new Set(['/dashboardadmin']);

  rawPaths
    .map(normalizePath)
    .filter(Boolean)
    .forEach(path => pathSet.add(path));

  return Array.from(pathSet);
};

export const hasAnyAllowedPath = (candidatePaths, userData = readStoredAdminUser()) => {
  const allowedPaths = getAllowedPaths(userData);
  const normalizedCandidates = (Array.isArray(candidatePaths) ? candidatePaths : [candidatePaths])
    .map(normalizePath)
    .filter(Boolean);

  if (allowedPaths.includes('*')) {
    return true;
  }

  return normalizedCandidates.some(candidate =>
    allowedPaths.some(allowedPath => pathMatches(allowedPath, candidate))
  );
};

export const isSuperAdminUser = (userData = readStoredAdminUser()) => {
  return isAdminUser(userData) && getAllowedPaths(userData).includes('*');
};

export const hasAccess = (accessKey, userData = readStoredAdminUser()) => {
  if (!accessKey) {
    return true;
  }

  const normalizedAccessKey = normalizePath(accessKey);
  const allowedPaths = getAllowedPaths(userData);
  const hasExplicitPathAccess = hasAnyAllowedPath(normalizedAccessKey, userData);

  if (normalizedAccessKey === '/modules') {
    return isSuperAdminUser(userData);
  }
  if (normalizedAccessKey === '/fitness-transactions') {
    return hasExplicitPathAccess;
  }
  if (normalizedAccessKey === '/session-clients') {
    return hasExplicitPathAccess;
  }
  if (normalizedAccessKey === '/fitness-transactions/setup') {
    return isManagementUser(userData) && hasExplicitPathAccess;
  }
  if (
    normalizedAccessKey === '/pos-categories' ||
    normalizedAccessKey === '/pos-products' ||
    normalizedAccessKey === '/pos-customers' ||
    normalizedAccessKey === '/pos-items' ||
    normalizedAccessKey === '/pos-laundry-methods' ||
    normalizedAccessKey === '/pos-laundry-times' ||
    normalizedAccessKey === '/pos-purchases' ||
    normalizedAccessKey === '/pos-stock-adjustments' ||
    normalizedAccessKey === '/pos-stock-opnames'
  ) {
    return isManagementUser(userData) && hasExplicitPathAccess;
  }
  if (
    normalizedAccessKey === '/pos-pengajuan-pembatalan' ||
    normalizedAccessKey === '/pos-approval-pembatalan' ||
    normalizedAccessKey === '/pos-refund-void-approval'
  ) {
    return isManagementUser(userData) && hasExplicitPathAccess;
  }
  if (
    normalizedAccessKey === '/accounting-setup' ||
    normalizedAccessKey === '/asset-management' ||
    normalizedAccessKey === '/pos-vendors'
  ) {
    return isAdminUser(userData) && hasExplicitPathAccess;
  }
  if (
    normalizedAccessKey === '/fitness-finance' ||
    normalizedAccessKey === '/operasional-finance'
  ) {
    return (
      isManagementUser(userData) &&
      hasAnyAllowedPath(['/operasional-finance', '/accounting-setup'], userData)
    );
  }
  if (normalizedAccessKey === '/pos-account-mappings') {
    return isManagementUser(userData) && hasExplicitPathAccess;
  }
  if (normalizedAccessKey === '/pos-sync-monitor') {
    return isAdminUser(userData) && hasExplicitPathAccess;
  }
  if (normalizedAccessKey === '/report-center') {
    return hasExplicitPathAccess;
  }

  if (allowedPaths.includes('*')) {
    return true;
  }

  return allowedPaths.some(
    allowedPath => pathMatches(allowedPath, normalizedAccessKey)
  );
};

export const getAccessKeyForPath = pathname => {
  const normalizedPath = normalizePath(pathname);
  if (!normalizedPath || normalizedPath === '/logout') {
    return null;
  }

  const matchedRule = ROUTE_ACCESS_RULES.find(rule => normalizedPath.startsWith(rule.prefix));
  return matchedRule ? matchedRule.accessKey : normalizedPath;
};

export const hasAccessToPath = (pathname, userData = readStoredAdminUser()) =>
  hasAccess(getAccessKeyForPath(pathname), userData);

export const filterAdminNavigationSections = (sections, userData = readStoredAdminUser(), searchQuery = '') => {
  const normalizedSearch = searchQuery.trim().toLowerCase();

  return sections
    .map(section => ({
      ...section,
      items: section.items.filter(item => {
        const matchesSearch =
          normalizedSearch === '' || item.label.toLowerCase().includes(normalizedSearch);
        const passesVisibilityRules =
          (!item.adminOnly || isAdminUser(userData)) &&
          (!item.managementOnly || isManagementUser(userData)) &&
          (!item.outletOnly || isOutletUser(userData)) &&
          (!item.hideForKaryawan || !isKaryawanUser(userData));
        return matchesSearch && passesVisibilityRules && hasAccess(item.to, userData);
      }),
    }))
    .filter(section => section.items.length > 0);
};
